<template>
  <section id="userIndex">
    <v-row justify="space-between" align="center">
      <v-col cols="7" md="auto" class="flex-grow-1 d-flex align-center">
        <v-btn
          @click="backAction"
          rounded
          class="rounded-xl mr-3"
          small
          plain
          min-width="0"
          :dark="isDark"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h2
          :class="[
            isMobile ? 'h5' : 'h4',
            isMobile && isDark ? 'white--text' : 'primary--text',
          ]"
          style="word-break: normal"
        >
          Resultados de busqueda
        </h2>
      </v-col>
    </v-row>
    <v-row justify="end" class="align-center">
      <v-col cols="12" md="auto">
        <v-text-field
          filled
          rounded
          dense
          readonly
          @click="openSearchDialog"
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card class="shadow-1 mt-5">
      <v-card flat>
        <!-- Tabla -->
        <v-container>
          <v-skeleton-loader v-if="isLoading" type="table"> </v-skeleton-loader>

          <v-row v-else dense justify="end">
            <v-col cols="12">
              <vuescroll
                :ops="{
                  bar: {
                    background: '#bacfcec0',
                    keepShow: true,
                  },
                }"
              >
                <v-data-table
                  :headers="tableHeaders"
                  :items="reportsList"
                  class="elevation-0"
                  :items-per-page="15"
                  :options.sync="tableOptions"
                  :server-items-length="totalItems"
                  :loading="isLoadingTable"
                  :footer-props="{
                    itemsPerPageOptions: [0, 15],
                  }"
                >
                  <template v-slot:[`item.date`]="{ item }">
                    <span class="d-inline pr-2">
                      {{ normalizeDate(item.date) }}
                    </span>
                  </template>
                  <template v-slot:[`item.user`]="{ item }">
                    <span class="d-inline pr-2">
                      {{ item.user.name }}
                    </span>
                  </template>
                  <template v-slot:[`item.extension`]="{ item }">
                    <span class="d-inline pr-2">
                      {{ item.extension }}
                    </span>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-hover v-slot:default="{ hover }">
                      <v-btn
                        text
                        icon
                        :color="hover ? 'accent' : 'blue-grey'"
                        @click.stop="viewResults(item)"
                      >
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </v-hover>
                    <v-hover v-if="user === 'agent'" v-slot:default="{ hover }">
                      <v-btn
                        text
                        icon
                        :color="hover ? 'accent' : 'blue-grey'"
                        @click.stop="openAgentComment(item)"
                      >
                        <v-icon>mdi-comment</v-icon>
                      </v-btn>
                    </v-hover>
                  </template>
                </v-data-table>
              </vuescroll>
            </v-col>
          </v-row>
        </v-container>
        <!-- Results -->
        <v-dialog
          v-model="resultsDialog"
          v-if="resultsDialog"
          scrollable
          max-width="1000"
        >
          <v-card>
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="primary"
              rounded
              height="6"
            ></v-progress-linear>
            <v-card-title class="pa-0 shadow-1">
              <v-img
                :src="require('@/assets/illustrations/bg_modal_card.svg')"
                cover
                position="left bottom"
                class="align-center"
                height="65px"
              >
                <v-card-title class="font-weight-medium primary--text">
                  Resumen
                </v-card-title>
              </v-img>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <div class="py-0 px-3 d-flex">
                    <p class="mb-0 mr-3">
                      <span class="info--text">Origen:</span>
                      {{ itemToResults.origin || "Sin datos" }}
                    </p>
                    <p class="mb-0 mr-3">
                      <span class="info--text">Destino:</span>
                      {{ itemToResults.destination || "Sin datos" }}
                    </p>
                    <p class="mb-0 mr-3">
                      <span class="info--text">Duracion:</span>
                      {{ itemToResults.duration | secondsToTimeFormat }}
                    </p>
                  </div>
                  <audio style="width: 100%" controls preload="none">
                    <source :src="recordingToShow.wav" type="audio/wav" />
                    <source :src="recordingToShow.mp3" type="audio/mpeg" />
                    <p>
                      Tu navegador no implementa el elemento audio.
                    </p>
                  </audio>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-row justify="center">
                    <v-col cols="12">
                      <h5 class="primary--text font-weight-medium ma-0">
                        Detalles
                      </h5>
                    </v-col>
                    <v-col cols="10" class="pa-0">
                      <p class="ma-0">
                        Agente:&nbsp;
                        <span class="text-subtitle-1  text-capitalize text--primary">{{
                          itemToResults.user.name
                        }}</span>
                      </p>
                    </v-col>

                    <v-col cols="10" class="pa-0">
                      <p class="ma-0">
                        Fecha:&nbsp;
                        <span class="text-subtitle-1  text-capitalize text--primary">
                          {{ itemToResults.date }}
                        </span>
                      </p>
                    </v-col>
                    <v-col cols="10" class="pa-0">
                      <p class="ma-0">
                        Observaciones:&nbsp;
                        <span class="text-subtitle-1  text-capitalize text--primary">
                          {{ itemToResults.observations }}
                        </span>
                      </p>
                    </v-col>
                    <!-- <v-col cols="10" class="pa-0">
                    <p class="primary--text ma-0">
                      {{ `Grabacion: ${itemToResults.recordings}` }}
                    </p>
                  </v-col> -->
                    <v-col cols="12">
                      <h5 class="primary--text font-weight-medium ma-0">
                        Respuestas
                      </h5>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="tablaModal"
                    :items="itemToResults.test_response"
                    :items-per-page="-1"
                    item-key="id"
                    show-expand
                    single-expand
                    hide-default-footer
                  >
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="text--secondary">
                        {{ item.observation || "Sin observaciones" }}
                      </td>
                    </template>
                    <template
                      v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }"
                    >
                      <v-btn icon v-show="item.observation" @click="expand(!isExpanded)">
                        <v-icon>
                          {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
    </v-card>
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vuescroll from "vuescroll";
import recordingPathGenerator from "../Utils/recordingPathGenerator";
import { PbxHttpClient } from "@/services/httpclient";
export default {
  components: { vuescroll },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
    searchParams: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      reportsList: [],
      tableHeaders: [
        {
          text: "Fecha",
          value: "date",
          width: "16%",
        },
        {
          text: "Usuario",
          value: "user",
          width: "10%",
        },
        {
          text: "Extensión",
          value: "extension",
          width: "10%",
        },
        {
          text: "Numero",
          value: "number",
          width: "10%",
        },
        {
          text: "puntaje obtenido",
          value: "value",
          width: "15%",
        },
        {
          text: "Observación",
          value: "observations",
          width: "17%",
        },
        {
          text: "Comentarios del agente",
          value: "agent_comment",
          width: "17%",
        },

        {
          text: "Acciones",
          value: "action",
          width: "15%",
        },
      ],
      tablaModal: [
        {
          text: "Pregunta",
          value: "question.name",
          width: "60%",
        },
        {
          text: "Respuesta",
          value: "answer.name",
          width: "20%",
        },
        {
          text: "Valor",
          value: "answer.value",
          width: "20%",
        },
        { text: "", value: "data-table-expand" },
      ],
      itemToResults: {},
      recordingUrl: "",
      recordingToShow: {
        wav: "",
        mp3: "",
      },
      resultsDialog: false,
      agentCommentDialog: false,
      agentCommentInput: "",
      commentTestId: null,
      isLoading: true,
      isLoadingTable: false,
      isDownloadingReport: false,
      activeGraph: false,
      evaluationToShow: null,
      mainSection: true,
      page: 1,
      totalItems: 0,
      tableOptions: {},
    };
  },
  created() {
    this.getReports();
    this.getRecordingUrl();
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },
  watch: {
    page() {
      this.getReports();
    },
    searchParams: {
      handler() {
        if (this.tableOptions.page !== 1) this.tableOptions.page = 1;
        else this.getReports();
        this.getRecordingUrl();
      },
      deep: true,
    },
    tableOptions: {
      handler() {
        this.getReports();
      },
      deep: true,
    },
  },

  methods: {
    async viewResults(item) {
      await this.getTest(item.id);
      this.recordingToShow.wav = `http://${this.recordingUrl}${recordingPathGenerator(
        item.recordings
      )}`;

      this.recordingToShow.mp3 = `http://${this.recordingUrl}${recordingPathGenerator(
        item.recordings,
        true
      )}`;
      this.resultsDialog = true;
    },
    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    backAction() {
      this.$emit("action:back");
    },
    openSearchDialog() {
      this.$emit("click:search");
    },
    async getReports() {
      this.isLoadingTable = true;
      const page = this.tableOptions?.page || 1;
      const itemPerPage = this.tableOptions?.itemsPerPage || 15;
      try {
        const { data } = await PbxHttpClient.get("quality/report/search", {
          params: { ...this.searchParams, page, itemPerPage },
        });

        this.reportsList = data.data;
        this.totalItems = data.total;
      } catch (error) {
        console.error(error);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
      this.isLoadingTable = false;
      this.isLoading = false;
    },
    async getRecordingUrl() {
      // this.isLoading = true;
      const accessToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_ROOTAPI}/url_client`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        this.recordingUrl = data.url;
        // console.log("URL", data);
      } catch (err) {
        console.log(err);
      }
      // this.isLoading = false;
    },

    //Store
    async getTest(id) {
      try {
        const { data } = await PbxHttpClient.get(`/quality/test/${id}`);
        this.itemToResults = data.data;
      } catch (err) {}
    },
    async sendAgentComment() {
      const accessToken = localStorage.getItem("token");
      try {
        const { data } = await axios.put(
          `${process.env.VUE_APP_ROOTAPI}/report/agent/update_comment/${this.commentTestId}`,
          { comment: this.agentCommentInput },
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        this.reportsList = this.reportsList.map((el) =>
          el.id === this.commentTestId ? data.test : el
        );
        this.$snotify.success("Comentario agregado con éxito.", "¡Hecho!");
      } catch (error) {
        // console.error(error);
        this.$snotify.error("Hubo un error publicando el comentario.", "Error");
      }
      this.closeAgentComment();
    },
    openAgentComment(item) {
      this.commentTestId = item.id;
      this.agentCommentInput = item.agent_comment || "";
      this.agentCommentDialog = true;
    },
    closeAgentComment() {
      this.agentCommentDialog = false;
      this.commentTestId = null;
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}
</style>
